/**
 * 单位隔离（CR-073）。**「谁看得到哪家的数据」只在这里判断**，后端每个 service、前端每个下拉都问这一份。
 *
 * 背景：客户把系统推给几家互不相关的公司用，自己当运营方 ——「这四个管理员能看到的用户，只能是自己创建的用户。
 * 角色这一块，他们也能创建角色但是只能用于自己的分公司」。同一套逻辑以后单独部署给一家大公司时，
 * 「单位」就是它的分公司（`ORG_KIND=branch`，只换文案）。
 *
 * 归属挂在**单位**上，不挂在创建者身上（成熟产品一律如此：人属于组织单元，管理员是挂在单元上的角色）：
 * 换管理员、一家两个管理员、超管代建，都不会出现「看不到」。
 *
 * - `orgId == null` 的账号是**平台账号**（超管永远是）：看全部，能干什么仍由角色决定；
 * - `orgId == X` 的账号只看 X 的人、X 的工地、X 的审计；角色额外看得到平台共享的（`Role.orgId == null`）。
 *
 * 漏问一处就是跨单位越权 —— 多租户下那是事故，不是 bug。
 */
/** 部署模式：多家公司共用一套（运营方 = 平台），或一家公司内分分公司（总部）。只影响文案 */
export const OrgKind = {
    COMPANY: 'company',
    BRANCH: 'branch',
};
export function isOrgKind(value) {
    return value === OrgKind.COMPANY || value === OrgKind.BRANCH;
}
/** 操作者的范围。`orgId` 用 `=== null` 判（约束 11：id 不用真值判断） */
export function scopeOf(actor) {
    return actor.orgId === null ? { all: true } : { all: false, orgId: actor.orgId };
}
/** 这一行（人、工地、审计）在不在范围里 */
export function inScope(scope, orgId) {
    return scope.all || orgId === scope.orgId;
}
/** 角色看不看得到：本单位的 + 平台共享的 */
export function roleInScope(scope, roleOrgId) {
    return scope.all || roleOrgId === null || roleOrgId === scope.orgId;
}
/**
 * 这个角色能不能给这个人：共享角色给谁都行，单位自建的只能给同一家的人。
 * **角色不决定人的归属** —— A 的张三和 B 的李四都是「分包工头」，各看各的。
 * 平台账号只能挂共享角色（它不属于任何一家，挂不上某家自建的）。
 */
export function roleFitsUser(roleOrgId, userOrgId) {
    return roleOrgId === null || roleOrgId === userOrgId;
}
/** 人能不能进这个工地：平台账号哪家的都能进，其余只能进自己单位的 */
export function userFitsSite(userOrgId, siteOrgId) {
    return userOrgId === null || userOrgId === siteOrgId;
}
/** Prisma 片段：人 / 工地 / 审计按单位过滤。平台账号不加条件 */
export function orgFilter(scope) {
    return scope.all ? {} : { orgId: scope.orgId };
}
/** Prisma 片段：角色 = 共享的 ∪ 本单位的 */
export function roleFilter(scope) {
    return scope.all ? {} : { OR: [{ orgId: null }, { orgId: scope.orgId }] };
}
//# sourceMappingURL=org-scope.js.map